export default __webpack_public_path__ + "scenes3c61531.png";